import type { SVGProps } from 'react'

import { CustomIconProps } from '@/shared/ui/icon-template'

export const ShoppingSvg = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
			<path
				d="M5 5H35V27.6667C35 29.8758 33.2091 31.6667 31 31.6667H9C6.79086 31.6667 5 29.8758 5 27.6667V5Z"
				fill="url(#paint0_linear_19699_42455)"
			/>
			<path
				d="M5 13.334H35V32.6673C35 34.8765 33.2091 36.6673 31 36.6673H9C6.79086 36.6673 5 34.8765 5 32.6673V13.334Z"
				fill="#4A4A4A"
			/>
			<path
				d="M13.332 21.666C13.332 21.666 13.332 26.666 19.9987 26.666C26.6654 26.666 26.6654 21.666 26.6654 21.666"
				stroke="white"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_19699_42455"
					x1="3.50003"
					y1="33.1481"
					x2="3.50003"
					y2="3.51852"
					gradientUnits="userSpaceOnUse">
					<stop offset="0.317788" stopColor="#5C90FC" />
					<stop offset="0.849586" stopColor="#B7D2FF" />
				</linearGradient>
			</defs>
		</svg>
	)
}
